import { memo, useCallback, useEffect, useState, type ReactNode } from 'react'
import { HttpError } from '../../lib/http.js'
import { setupApi, type SetupStatusResponse } from '../../lib/setupApi.js'
import { AuthGate } from '../auth/AuthGate.js'
import { Skeleton } from '../ui/skeleton.js'
import { SetupWizard } from './SetupWizard.js'
import './SetupWizard.css'

export const SetupGate = memo(function SetupGate({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<SetupStatusResponse | null>(null)
  const [ready, setReady] = useState(false)
  const [error, setError] = useState('')
  const refresh = useCallback(async () => {
    try {
      const next = await setupApi.status()
      setStatus(next); setReady(next.status === 'READY'); setError('')
    } catch (caught) {
      if (caught instanceof HttpError && caught.status === 404) { setReady(true); setError(''); return }
      setError('Le serveur d’installation ne répond pas. Vérifiez le contrôleur puis réessayez.')
    }
  }, [])
  useEffect(() => { void refresh() }, [refresh])
  if (ready) return <AuthGate>{children}</AuthGate>
  if (error) return <main className="setup-shell tp-form-surface"><section className="setup-loading" role="alert"><h1>TrafficPlay</h1><p>{error}</p><button className="tp-button tp-button--primary" onClick={() => void refresh()}>Réessayer</button></section></main>
  if (!status) return <main className="setup-shell tp-form-surface"><section className="setup-loading"><Skeleton className="h-8 w-48" /><Skeleton className="h-4 w-72" /><Skeleton className="h-48 w-full" /></section></main>
  return <SetupWizard initial={status} onReady={() => { setReady(true); void refresh() }} onStatus={setStatus} />
})
